import React from 'react';

import { useIntl } from 'react-intl';
import { Sliders } from 'lucide-react';

import TabsHeader from 'components/tabs-header';
import { useParams } from 'react-router';
import { SiteTab } from 'views/site-settings/types/site-tab.type';

type ParamTypes = {
  globalSiteId: string;
  siteTab: string;
};


type SiteSettingsTabHeaderProps = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const SiteSettingTabsHeader: React.FC<SiteSettingsTabHeaderProps> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const params = useParams<ParamTypes>();

  const tabRedirection = () => {
    return params.siteTab === SiteTab.ACTIVE ? 'sites'
      : params.siteTab === SiteTab.INACTIVE ? 'inactive-sites'
        : params.siteTab === SiteTab.SITES_WITHOUT_MAPPING ? 'sites-without-mapping'
          : 'sites';
  };

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'siteSettings.navigation.listSites' }),
          to: `/site-settings/${tabRedirection()}`,
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Sliders size={25} color={'white'} />}
    />
  );
};

export default React.memo(SiteSettingTabsHeader);
